/** Used for Message, Hint, Toasts and Modals */
export enum BaseTone {
  INFO = 'info',
  NEUTRAL = 'neutral',
  POSITIVE = 'positive',
  CAUTION = 'caution',
  CRITICAL = 'critical',
}

/** Used for icons and text */
export enum IconTextTone {
  INFO = BaseTone.INFO,
  NEUTRAL = BaseTone.NEUTRAL,
  POSITIVE = BaseTone.POSITIVE,
  CAUTION = BaseTone.CAUTION,
  CRITICAL = BaseTone.CRITICAL,
  ACTION = 'action',
  BASE = 'base',
  INVERT = 'invert',
  DISABLED = 'disabled',
}

/** Used for tags */
export enum TagTone {
  INFO = BaseTone.INFO,
  POSITIVE = BaseTone.POSITIVE,
  CAUTION = BaseTone.CAUTION,
  CRITICAL = BaseTone.CRITICAL,
  BRAND = 'brand',
  NEUTRAL = BaseTone.NEUTRAL,
}

/** Used for backgrounds */
export enum BackgroundTone {
  INFO = BaseTone.INFO,
  NEUTRAL = BaseTone.NEUTRAL,
  POSITIVE = BaseTone.POSITIVE,
  CAUTION = BaseTone.CAUTION,
  CRITICAL = BaseTone.CRITICAL,
  DEFAULT = 'default',
  INVERT = 'invert',
  PRIMARY = 'primary',
  GHOST = 'ghost',
}

/** Used for buttons variant */
export enum ButtonTone {
  PRIMARY = 'primary',
  DESTRUCTIVE = 'destructive',
  OUTLINE = 'outline',
  OUTLINE_DESTRUCTIVE = 'outline-destructive',
  GHOST = 'ghost',
  GHOST_MUTED = 'ghost-muted',
  GHOST_DESTRUCTIVE = 'ghost-destructive',
}
